import(/* webpackMode: "eager" */ "/vercel/path0/app/providers.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-loading-skeleton/dist/skeleton.css");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/reset.css");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/styles/htmlReports/index.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@react-pdf-viewer/default-layout/lib/styles/index.css");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@react-pdf-viewer/core/lib/styles/index.css")